export class QrefPd5861Model {
  code: string;
  description: string;

  constructor() {
  }
}

